var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.8 156.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#5abcd3;}.cls-3{fill:none;stroke:#e13333;stroke-miterlimit:10;}.cls-4{fill:#161615;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    className: "cls-1",
    d: "M95.53,48.5a6.4,6.4,0,1,0-6.4,6.4,6.39,6.39,0,0,0,6.4-6.4h0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    className: "cls-2",
    d: "M78.13,156.25H50C-11.54,156.25-3.93,61.72,8.74,22a50.79,50.79,0,0,1,6.1-7.38A49.66,49.66,0,0,1,50,0H78.13a49.52,49.52,0,0,1,31.64,11.41,50.68,50.68,0,0,1,4.1,3.79C127,28.74,128,49.72,128.46,67.47c.5,20.4,1.65,42.11-7.15,61.1-5.87,12.67-15.22,22.13-33.17,26.66a50.11,50.11,0,0,1-10,1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    className: "cls-1",
    d: "M7.19,36.58c0-15.63,56.59-15.63,56.59,0a28.3,28.3,0,1,1-56.59.82v-.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    className: "cls-3",
    d: "M7.19,36.58c0-15.63,56.59-15.63,56.59,0a28.3,28.3,0,1,1-56.59.82Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    className: "cls-4",
    d: "M17.41,37.21c0-10.79,39.09-10.79,39.09,0a19.55,19.55,0,1,1-39.09,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    className: "cls-1",
    d: "M32.92,48.5a6.4,6.4,0,1,1,6.4,6.4,6.39,6.39,0,0,1-6.4-6.4h0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    className: "cls-1",
    d: "M121.26,36.58c0-15.63-56.6-15.63-56.6,0a28.3,28.3,0,0,0,56.6.82v-.82"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    className: "cls-3",
    d: "M121.26,36.58c0-15.63-56.6-15.63-56.6,0a28.3,28.3,0,0,0,56.6.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    className: "cls-4",
    d: "M111,37.21C111,26.42,72,26.42,72,37.21a19.55,19.55,0,1,0,39.09,0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cls-1",
    d: "M27,73.66c.31-1.26,11.75-.27,25.1-7.89,6.51-3.71,10-7.48,10.9-7,1.18.66-2.52,8.08-9.28,12.55-11.4,7.55-27.09,3.8-26.72,2.3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    className: "cls-1",
    d: "M102,73.39c-.31-1.26-11.74-.27-25.1-7.89-6.51-3.71-10-7.48-10.9-7-1.18.66,2.53,8.08,9.28,12.55,11.39,7.55,27.09,3.81,26.72,2.3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/Icon1.f4f5f31c96cbd3a2be5cf22d79b5b260.svg";
export { ForwardRef as ReactComponent };